if (!customElements.get('product-showcase-carousel')) {
  customElements.define('product-showcase-carousel', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.ps-carousel__viewport');
      this.previous = this.querySelector('[data-ps-previous]');
      this.next = this.querySelector('[data-ps-next]');
      this.controls = this.querySelector('.ps-carousel__controls');
      if (!this.viewport || !this.previous || !this.next) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.viewport.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.viewport.addEventListener('keydown', (event) => {
        if (event.target !== this.viewport || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const rtl = getComputedStyle(this.viewport).direction === 'rtl';
        this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.viewport);
      const grid = this.viewport.querySelector('.ps-grid');
      if (grid) this.observer.observe(grid);
      this.update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }

    update() {
      const max = this.viewport.scrollWidth - this.viewport.clientWidth;
      const position = Math.abs(this.viewport.scrollLeft);
      this.controls.hidden = max <= 2;
      this.previous.disabled = position <= 2;
      this.next.disabled = position >= max - 2;
    }

    move(direction) {
      const card = this.viewport.querySelector('.ps-card');
      if (!card) return;
      const grid = this.viewport.querySelector('.ps-grid');
      const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
      const step = card.getBoundingClientRect().width + gap;
      const rtl = getComputedStyle(this.viewport).direction === 'rtl';
      this.viewport.scrollBy({
        left: step * direction * (rtl ? -1 : 1),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
  });
}
